var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-wrapper"},[_c('vue-editor',{model:{value:(_vm.editorContent),callback:function ($$v) {_vm.editorContent=$$v},expression:"editorContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }